export function readMoreModal($) {
    $('.modal-read-more').on('click', function () {
        var key = $(this).data('key');

        $('.accordion-button').addClass('collapsed');
        $('.accordion-collapse').removeClass('show');

        $('.' + key + ' .accordion-button').removeClass('collapsed');
        $('.' + key + ' .accordion-collapse').addClass('show');
    });
}

export function sliceContent($) {
    $(".text-content").each(function () {
        var count = $('.product-featured-container').data('count');

        if (count > 3) {
            var maxLength = 200;
            var strippedContent = $(this).text();

            if (strippedContent.length > maxLength) {
                var truncated = strippedContent.slice(0, maxLength) + '...';
                $(this).html(truncated);
            }
        }
    });
}